import { Link } from 'react-router-dom'
import React from 'react'
import { Transfer } from '../../types'
import ListGroup from '../ListGroup'
import { TransferSummaryListItem } from '../TransferSummaryList'

interface Props {
  transfers: Transfer[]
}

const UpcomingBookingsList: React.FC<Props> = ({ transfers }) => {
  return (
    <div className="upcoming-bookings mt-3">
      <ListGroup.Items>
        {transfers.slice(0, 2).map((item) => (
          <ListGroup.Item hover key={item.booking_id}>
            <Link to={`/my-transfers/?booking_id=${item.booking_id}`} className="text-secondary text-decoration-none">
              <TransferSummaryListItem icon transfer={item} key={item.booking_id} />
            </Link>
          </ListGroup.Item>
        ))}

        {transfers.length > 2 && (
          <ListGroup.Item>
            <Link to="/my-transfers/" className="d-block text-center p-3 leading-1 text-secondary align-items-center">
              <u>See {transfers.length - 2} more transfers</u>
            </Link>
          </ListGroup.Item>
        )}
      </ListGroup.Items>
    </div>
  )
}

export default UpcomingBookingsList
